import {MatPaginatorIntl} from '@angular/material';

// Helper: format number with space as thousands separator
function formatNumber(value: number): string {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}


const polishRangeLabel = (page: number, pageSize: number, length: number) => {
  if (length === 0 || pageSize === 0) {
    return `0 z ${length}`;
  }

  length = Math.max(length, 0);

  const startIndex = page * pageSize;

  // If the start index exceeds the list length, do not try and fix the end index to the end.
  const endIndex = startIndex < length ?
    Math.min(startIndex + pageSize, length) :
    startIndex + pageSize;

  // return `${startIndex + 1} - ${endIndex} z ${length}`;

  return `${formatNumber(startIndex + 1)} - ${formatNumber(endIndex)} z ${formatNumber(length)}`;
};


export function getPolishPaginatorIntl() {
  const paginatorIntl = new MatPaginatorIntl();

  paginatorIntl.itemsPerPageLabel = 'Przedmioty na stronę:';
  paginatorIntl.nextPageLabel = 'Następna strona';
  paginatorIntl.previousPageLabel = 'Poprzednia strona';
  paginatorIntl.getRangeLabel = polishRangeLabel;
  paginatorIntl.lastPageLabel = 'Ostatnia strona';
  paginatorIntl.firstPageLabel = 'Pierwsza strona';
  return paginatorIntl;
}
